import $axios from "@src/_common/service/httpServer";
import $config from '@/config/index'

// 登陆相关
export const getVerify = p => $axios.get('/auth/oasso/verifycode', p, { Authorization: $config.defaultAuthorization }) // 获取验证码
export const login = p => $axios.postFormData('/auth/oauth/token', p, { Authorization: $config.defaultAuthorization}) // 登陆
export const loginByOA = p => $axios.postFormData('/auth/oasso/token', p, { Authorization: $config.defaultAuthorization}) // 登陆
// 登陆
export const getUserPermission = () => $axios.get('/auth/user/permissions', { appCode: $config.appCode }) // 获取用户权限列表
export const getUserInfo = () => $axios.get('/upms/personInfo/detail') // 获取用户基本信息
export const logout = () => $axios.post('/auth/oauth/logout') // 退出登陆
//h5跟投登录
export const h5InvestLoginByApp = ( p,token ) => $axios.post('/auth/user/token/convert', p, { Authorization: 'Bearer '+ token }) // 登陆

// 获取 ossToken
export const getOssToken = p => $axios.get('/auth/ossToken/stsToken');